// extracted by mini-css-extract-plugin
export default {"button":"BreadcrumbButton_button__3C4JP","button--disabled":"BreadcrumbButton_button--disabled__8pqQS"};